import { render, staticRenderFns } from "./qualification-index.vue?vue&type=template&id=21f45788&scoped=true"
import script from "./qualification-index.vue?vue&type=script&lang=js"
export * from "./qualification-index.vue?vue&type=script&lang=js"
import style0 from "./qualification-index.vue?vue&type=style&index=0&id=21f45788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f45788",
  null
  
)

export default component.exports